import React, { useRef } from 'react';
import { AuthContainer, Input } from '../../../components';
import { notifyError } from '../../../utils/notify';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form, StyledButton } from './ForgotPasswordPage.styles';
import ReCAPTCHA from 'react-google-recaptcha';
import config from '../../../config';
import { requestVerificationCode } from '../../../store/slices/auth/asyncThunks';
import { VERIFICATION_CODE_TYPES } from '../../../utils/constants';
import { EMAIL_VERIFICATION } from '../../../components/App/routes';
import { useNavigate } from 'react-router-dom';
import { selectAuthActionsPending } from '../../../store/slices/auth/slice';

export const forgotPasswordFormSchema = yup
  .object({
    email: yup.string().trim().required('Email is required').email('Invalid email'),
  })
  .required();

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recaptchaRef = useRef();
  const { requestVerificationCode: requestVerificationCodePending } = useSelector(selectAuthActionsPending);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
    delayError: 300,
    resolver: yupResolver(forgotPasswordFormSchema),
  });

  const onSubmit = async data => {
    const { email } = data;
    const recaptchaValue = await recaptchaRef.current.executeAsync();

    dispatch(requestVerificationCode({ email, token: recaptchaValue, type: VERIFICATION_CODE_TYPES.FORGOT_PASSWORD }))
      .unwrap()
      .then(() => {
        navigate(`/${EMAIL_VERIFICATION}`, { state: { email, type: VERIFICATION_CODE_TYPES.FORGOT_PASSWORD } });
      })
      .catch(err => {
        recaptchaRef.current.reset();
        notifyError(err.message);
      });
  };
  return (
    <AuthContainer title="Forgot Password?" subtitle="Enter email to continue">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Input placeholder="Enter your email address" {...register('email')} error={errors.email?.message} />
        <StyledButton title="Continue" type="submit" isLoading={requestVerificationCodePending} />
      </Form>
      <ReCAPTCHA ref={recaptchaRef} sitekey={config.googleRecaptcha.key} size="invisible" />
    </AuthContainer>
  );
};

export default ForgotPasswordPage;
